<template>
    <div>
        <div class="container-padded">
            <h1 class="mb-4">Typography</h1>
            <h1>Heading 1 - Lato 30 px</h1>
            <h2>Heading 2 - Lato 24 px</h2>
            <p>Body - Lato 20 px</p>
            <p><em>Hint - Lato 16 px</em></p>
        </div>

        <div class="container-padded bg-salesium-grey-50 text-black">
            <h1 class="mb-4">Colors</h1>
            <span class="block">salesium-grey-50</span>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-black text-white">
                black
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-salesium-grey-100 text-black">
                salesium-grey-100
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-white text-black">
                white
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-salesium-blue text-white">
                salesium-blue
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-salesium-red text-white">
                salesium-red
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-salesium-bronze text-white">
                salesium-bronze
            </div>
            <div class="relative inline-block w-48 h-32 p-1 m-5 rounded-lg bg-salesium-green text-white">
                salesium-green
            </div>
        </div>

        <div class="container-padded">
            <h1 class="mb-4">Buttons</h1>
            <a class="primary-btn mr-2" href="#">Primary</a>
            <a class="secondary-btn" href="#">Secondary</a>
        </div>

        <div class="container-padded">
            <h1 class="mb-4">Icons</h1>
            TODO
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
